import { PlayerIcon } from "../assets/icons/playerIcon";
import styles from "./PriceInfoContainer.module.css";

const PriceInfoContainer = ({ players }) => {
  const p1 = players == 1;
  const p2 = players == 2;
  const pMany = players > 2;
  return (
    <div className={styles.priceInfoContainer}>
      <div className={styles.selectedPriceInfo}>
        <h2 className={`mt0 ${styles.deskHeader}`}>Price for current selection</h2>
        <h3 className="m0">
          1hr Premium
          {p1 && <span> - 110rs</span>}
          {p2 && <span> - 90rs</span>}
          {pMany && <span> - 75rs</span>}
        </h3>
        <h3 className="mb0">
          1hr Economy
          {p1 && <span> - 80rs</span>}
          {p2 && <span> - 70rs</span>}
          {pMany && <span> - 60rs</span>}
        </h3>
      </div>

      <div className={styles.allPriceInfo}>
        <h2 className="mb5">
          Price Info <span className={styles.headerLabel}>(for each)</span>
        </h2>
        <div className={styles.priceInfo}>
          <table className={styles.priceInfoTable}>
            <thead>
              <tr>
                <th></th>
                <th>
                  <div className={styles.heading}>Premium</div>
                  <div className={styles.subHeader}>(1 Hr)</div>
                </th>
                <th>
                  <div className={styles.heading}>Premium</div>
                  <div className={styles.subHeader}>(30 Min)</div>
                </th>
                <th>
                  <div className={styles.heading}>Economy</div>
                  <div className={styles.subHeader}>(1 Hr)</div>
                </th>
                <th>
                  <div className={styles.heading}>Economy</div>
                  <div className={styles.subHeader}>(30 Min)</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className={`${p1 ? styles.highlightPrice : ''}`}>
                <td>
                  <PlayerIcon />
                </td>
                <td>110rs</td>
                <td>70rs</td>
                <td>80rs</td>
                <td>60rs</td>
              </tr>
              <tr className={`${p2 ? styles.highlightPrice : ''}`}>
                <td>
                  <PlayerIcon />
                  <PlayerIcon />
                </td>
                <td>90rs</td>
                <td>60rs</td>
                <td>70rs</td>
                <td>50rs</td>
              </tr>
              <tr className={`${pMany ? styles.highlightPrice : ''}`}>
                <td className={`pr10 pl10`}>Many</td>
                <td>75rs</td>
                <td>50rs</td>
                <td>60rs</td>
                <td>40rs</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.simPriceInfo}>
        <div>
          <h3>VR</h3>
          <div> 15 min - 80rs</div>
        </div>
        <div>
          <h3>Car Simulator</h3>
          <div> 15 min - 75rs</div>
        </div>
      </div>
    </div>
  );
};

export default PriceInfoContainer;
